<a
    href="javascript:"
    (click)="toggle($event)"
    class="toggle-wrapper size-{{ size }} sm-size-{{ smSize }} orientation-{{ labelPosition }}"
>
    <ng-container *ngIf="!isLoading">
        <span class="toggle" [class.on]="isOn">
            <span class="handle"></span>
        </span>
        <span *ngIf="withStateLabel" class="state-label">{{ switchStateLabel }}</span>
        <span *ngIf="label" class="label">{{ label }}</span>
        <ng-content *ngIf="!label"></ng-content>
        <span
            *ngIf="infoIcon"
            class="toggle-info-icon-wrapper {{ infoIconWrapperMarker }}"
            (click)="onControlFocus($event)"
        >
            <span class="toggle-info-icon {{ infoIconMarker }}"></span>
        </span>
    </ng-container>

    <img *ngIf="isLoading" src="/images/spinner.svg" class="sp-dots-spinner spinner" />
</a>
